import React from 'react';
import HelpContent from './HelpContent';
//import proyeccionParticipacion from 'img/proyeccion_participacion.png';

const HidrogenoTermicoHelp = () => (
  <HelpContent>
    <h1>Uso de hidrógeno en procesos térmicos de la industria y minería</h1>
    <p>
    Esta medida evalúa el impacto del reemplazo de combustibles fósiles por hidrógeno en los procesos térmicos de la industria y minería. 
    La medida contempla su utilización como combustible dual en equipos estacionarios en la industria y minería (excluye cobre).
    </p>
    <p>
    <strong>Trayectoria 1:</strong> en industria y minería la participación de hidrógeno en usos térmicos es de 2% en 2030, un 4,4% en 2040 y alcanza un 9,4% en 2050.
    </p>
  </HelpContent>
);

export default HidrogenoTermicoHelp;
